(() => {
  class NewPromoController {
    constructor($q, $state, ngDialog, toastr, Utils, Services, Notifications, Promos) {
      'ngInject';

      Object.assign(this, {
        $state,
        $q,
        ngDialog,
        toastr,
        Notifications,
        Services,
        Promos,
        Utils,
        services: [],
        today: new Date(),
        customerTypes: [
          {
            code: Promos.CUSTOMER_TYPES.ALL,
            display: 'All',
          },
          {
            code: Promos.CUSTOMER_TYPES.NEW,
            display: 'New',
          },
          {
            code: Promos.CUSTOMER_TYPES.RETURNING,
            display: 'Returning',
          },
        ],
        types: [{
          code: Promos.MULTI_USE,
          display: 'Promo Code - Multi Use'
        }, {
          code: Promos.SINGLE_USE,
          display: 'Promo Code - Single Use'
        }, {
          code: Promos.EMAIL_DOMAIN,
          display: 'Email Domain'
        }],
        newPromo: {
          domains: [], // Have to instantiate array for chip component
        },
        MAX_USES: 5000
      });

      this.getServices();
    }

    getServices() {
      this.Services.list()
        .then(({ data: { data: serviceResp } }) => {
          this.services = serviceResp.map((service) => {
            if (service.children) {
              return service.children.map((childService) => {
                return {
                  ...childService,
                  isSelected: false,
                };
              });
            }
            return {
              ...service,
              isSelected: false,
            };
          }).flat();
        })
        .catch(() => {
          this.toastr.error("Could not get the list of services.");
        });
    }

    isIndeterminate() {
      const filteredServices = this.getFilteredServices();
      return (filteredServices.length !== 0 &&
        filteredServices.length !== this.services.length);
    }

    isChecked() {
      return this.getFilteredServices().length === this.services.length;
    }

    toggleAll() {
      const filteredServices = this.getFilteredServices();
      const toggleState = !(filteredServices.length === this.services.length);
      this.services.forEach((service) => {
        service.isSelected = toggleState;
      });
    }

    getFilteredServices() {
      return this.services.filter(service => service.isSelected);
    }
    /**
     * Create a new promotion
     */
    createPromo() {
      const filteredServices = this.getFilteredServices();
      this.newPromo.product_category_ids = filteredServices.length === this.services.length
        ? null
        : this.services.filter(service => service.isSelected)
          .map(service => service.id);
      // Only create if promo is valid
      if (!this.isPromoValid(this.newPromo)) {
        return;
      }

      let { count } = this.newPromo, // pluck out count in case of single use
        sanitizedPromo = this.sanitizePromo(this.newPromo),
        createdPromo;

      this.checkMaxUses(this.newPromo)
        .then(() => {
          this.creating = true;
          return this.Promos.create(sanitizedPromo);
        })
        .then(({ data }) => {
          createdPromo = data;
          if (createdPromo.type == this.Promos.SINGLE_USE) {
            return this.Promos.generateSingleUseCodes(createdPromo.id, count);
          } else {
            return null;
          }
        })
        .then(() => this.$state.go('promoDetail', { id: createdPromo.id }))
        .catch((err) => {
          if (err) {
            this.toastr.error(err.data.message.summary);
          }
        })
        .finally(() => this.creating = false);
    }
    /**
     * Sanitize a promotion before sending to server for creation
     * @param  {object} promo promotion object
     * @return {object}       sanitized promotion object
     */
    sanitizePromo(promo) {
      const promoCopy = angular.copy(promo);

      if (promoCopy.type === this.Promos.EMAIL_DOMAIN) {
        promoCopy.code = promoCopy.domains[0];
      } else {
        delete promoCopy.domains;
      }

      if (promoCopy.type === this.Promos.SINGLE_USE) {
        delete promoCopy.count;
      }

      if (promoCopy.discount.type === this.Promos.PERCENT) {
        promoCopy.discount.value /= 100;
      }

      return promoCopy;
    }
    /**
     * Determines if promotion has all necessary data and is ready to submit
     * @param  {Object} promo the new promotion object
     * @return {Boolean} whether or not the promotion is valid
     */
    isPromoValid(promo) {
      const errors = {};

      if (promo.discount) {
        const maximumDollarDiscount = 1000,
              maximumPercentDiscount = 100,
              minimumDiscountValue = 0;

        if (window.isNaN(promo.discount.value)) {
          errors.discount = this.Notifications.promos.discountNotANumber;
        }

        // ON SPRINT 134
        // We are removing the maximum validation for Dollar Discounts
        // if (promo.discount.type === this.Promos.DOLLAR && promo.discount.value > maximumDollarDiscount) {
        //   errors.discount = this.Notifications.promos.dollarDiscountTooHigh;
        // }


        if (promo.discount.type === this.Promos.PERCENT && promo.discount.value > maximumPercentDiscount) {
          errors.discount = this.Notifications.promos.percentDiscountTooHigh;
        }

        if (promo.discount.value < minimumDiscountValue) {
          errors.discount = this.Notifications.promos.discountValueTooLow;
        }
      }

      //
      if (promo.type == this.Promos.EMAIL_DOMAIN) {
        if (!promo.domains.length) {
          errors.emailDomain = this.Notifications.promos.noEmailDomains;
        }

        promo.domains.forEach(domain => {
          if (!this.Utils.domainRegex.test(domain)) {
            errors.emailDomain = `${domain} is not a valid email domain`;
          }
        });
      }

      const filteredService = this.getFilteredServices();
      if (filteredService.length === 0) {
        errors.services = this.Notifications.promos.minimumServiceRequired;
      }

      // No dates at all
      if (!promo.effective && !promo.expires) {
        errors.date = this.Notifications.promos.noDates;
      // No start date
      } else if (!promo.effective && promo.expires) {
        errors.date = this.Notifications.promos.noStartDate;
      // No end date
      } else if (promo.effective && !promo.expires) {
        errors.date = this.Notifications.promos.noEndDate;
      }

      this.errors = errors;
      return _.isEmpty(errors) ? true : false;
    }

    checkMaxUses(promo) {
      if (promo.type === this.Promos.SINGLE_USE && (parseInt(promo.max_uses) > this.MAX_USES || parseInt(promo.count) > this.MAX_USES)) {
        const dialogConfig = {
          template: 'app/components/modals/confirm.tpl.html',
          showClose: false,
          data: {
            title: 'Are you sure?',
            content: `You\'re creating a campaign with over ${this.MAX_USES} promotion codes. Are you sure you want to do this?`,
            buttons: {
              cancel: 'Cancel',
              confirm: 'Yes'
            }
          }
        };
        return this.ngDialog.openConfirm(dialogConfig);
      }

      return this.$q.resolve();
    }

  }

  NewPromoController.$inject = ["$q", "$state", "ngDialog", "toastr", "Utils", "Services", "Notifications", "Promos"];
  angular.module('pims').controller('NewPromoController', NewPromoController);
})();
